<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-4 is-offset-4">
          <h3 class="title has-text-grey">INSA | BackOffice</h3>
          <p class="subtitle has-text-grey">Faça upload do novo video (*.mp4)...</p>
          <div class="box">
            <div class="field">
              <div class="control">
                <input class="input" type="file" id="file" ref="file" v-on:change="onChangeFileUpload()">
              </div>
            </div>
            <button class="button is-block is-info is-fullwidth" :class="{'is-loading' : uploading}" v-on:click="submitForm()">Upload</button>
            <p class="help is-info" v-if="uploadComplete">Upload concluído com sucesso...</p>
            <p class="help is-info" v-if="uploadComplete">Deve reíniciar a APP no LCD!</p>
            <p class="help is-danger" v-if="uploadError">Erro no upload... Tente novamente!</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
  export default {
    data(){
      return {
        file: '',
        uploading: false,
        uploadComplete: false,
        uploadError: false
      }
    },
  
    methods: {
      submitForm(){
        this.uploading = true;
        let formData = new FormData();
        formData.append('file', this.file);

        this.axios.post('http://insa.virtualreflex.com/api/uploadVideo.php',
            formData,
            {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function(){
          // console.log(data.data);
          this.uploading = false;
          this.uploadComplete = true;
          this.file = null;
        }.bind(this))
        .catch(function(){
          // console.log('Erro!');
          this.uploading = false;
          this.uploadError = true;
          this.file = null;
        }.bind(this));
      },
  
      onChangeFileUpload(){
        this.file = this.$refs.file.files[0];
      }
    }
  }
</script>